import { getSubscriptionAdmin } from './session';
import { getUserRole } from '../utils/sessionStore';

const LEGACY_ROLE_MAP = {
  Hr: 'super_admin',
  ProjectManager: 'billing_admin',
  AdminController: 'viewer',
  Distributor: 'viewer',
  Adminsubscriptionuser: 'viewer',
};

const ROLE_PERMISSIONS = {
  super_admin: ['*'],
  billing_admin: [
    'plans:read',
    'offers:read',
    'offers:write',
    'contracts:read',
    'contracts:write',
    'contracts:activate_offline',
    'payments:record_manual',
    'subscriptions:read',
    'subscriptions:write',
    'payments:read',
    'payments:write',
    'invoices:read',
    'invoices:write',
    'reports:read',
    'usage:read',
    'notifications:read',
    'notifications:resend',
    'customers:read',
    'customers:write',
  ],
  viewer: [
    'plans:read',
    'offers:read',
    'contracts:read',
    'subscriptions:read',
    'payments:read',
    'invoices:read',
    'reports:read',
    'usage:read',
    'audit:read',
    'notifications:read',
    'customers:read',
  ],
};

export function getSubscriptionRole() {
  const fromSession = getSubscriptionAdmin()?.subscriptionRole;
  if (fromSession) return fromSession;
  const legacyRole = getUserRole();
  return LEGACY_ROLE_MAP[legacyRole] || null;
}

export function hasPermission(permission) {
  const role = getSubscriptionRole();
  if (!role) return false;
  const grants = ROLE_PERMISSIONS[role] || [];
  if (grants.includes('*')) return true;
  return grants.includes(permission);
}

export function canWrite(resource) {
  return hasPermission(`${resource}:write`);
}

export function canRead(resource) {
  return hasPermission(`${resource}:read`);
}
